module.exports = __webpack_public_path__ + "img/Piscina.68610e92.png";